import { styled } from "goober";

export const stepDetailsHeadingHeight = 40;

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  flex: 1;
  background: var(--surface-secondary);
  border-radius: 12px;
  border: 0.5px solid var(--border-alpha);
`;

const Heading = styled("div")`
  height: ${stepDetailsHeadingHeight}px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid var(--border-alpha);
`;

const Subheader = styled("div")`
  height: ${stepDetailsHeadingHeight}px;
  padding: 8px;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--border-alpha);
  flex-shrink: 0;
  overflow: hidden;
  animation: subheader-slide-down 160ms cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes subheader-slide-down {
    from {
      height: 0;
      border-bottom-color: transparent;
    }
    to {
      height: ${stepDetailsHeadingHeight}px;
      border-bottom-color: var(--border-alpha);
    }
  }
`;

const Body = styled("div")`
  padding: 12px;
  flex: 1;
  overflow: auto;
`;

const FlushBody = styled(Body)`
  padding: 0;
  container-type: inline-size;
`;

const Footer = styled("div")`
  height: ${stepDetailsHeadingHeight}px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 0.5px solid var(--border-alpha);
  flex-shrink: 0;
  overflow: hidden;
  animation: footer-slide-up 160ms cubic-bezier(0.16, 1, 0.3, 1);

  > * {
    animation: footer-fade-in 160ms cubic-bezier(0.16, 1, 0.3, 1);
  }

  @keyframes footer-slide-up {
    from {
      height: 0;
      border-top-color: transparent;
    }
    to {
      height: ${stepDetailsHeadingHeight}px;
      border-top-color: var(--border-alpha);
    }
  }

  @keyframes footer-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

type Props = {
  heading: React.ReactNode;
  headingRight?: React.ReactNode;
  subheader?: React.ReactNode;
  footer?: React.ReactNode;
  body: React.ReactNode;
  flushBody?: boolean;
};

export function StepDetails({
  heading,
  headingRight,
  subheader,
  footer,
  body,
  flushBody,
}: Props) {
  return (
    <Container>
      {heading && (
        <Heading>
          {heading}
          {headingRight}
        </Heading>
      )}
      {subheader && <Subheader>{subheader}</Subheader>}
      {flushBody ? <FlushBody>{body}</FlushBody> : <Body>{body}</Body>}
      {footer && <Footer>{footer}</Footer>}
    </Container>
  );
}
